import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <LangProvider>
            <BrowserRouter>
                <Toaster position="top-center" richColors />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </LangProvider>
    );
}

export default App;
